/**
 * Шапка приложения (`docs/spec/ui-blocks.md` §1).
 *
 * Переключателя ролей из макета (`#roleSeg`, `.seg.seg-dark`) здесь нет и быть не должно:
 * роль приходит из сессии. Вместо него — колокольчик и кнопка «Выйти».
 */

import { Link } from 'react-router-dom';

import { useAuth } from '../auth/AuthContext';
import { initialsOf, shortName } from '../lib/format';
import { NotificationBell } from './NotificationBell';

export function Header() {
    const { user, clinic, logout, logoutPending } = useAuth();

    const roleBadge = user
        ? user.role === 'chief'
            ? 'Главный врач'
            : (user.post ?? 'Исполнитель')
        : '';

    return (
        <header className="app-header">
            <div className="logo-area">
                <span className="logo-icon" aria-hidden="true">
                    🏛️
                </span>
                <div className="org-name">
                    {clinic?.name ?? 'Обращения граждан'}
                    <small>Департамент здравоохранения · Система обращений граждан</small>
                </div>
            </div>

            <div className="user-area">
                <NotificationBell />
                {roleBadge && roleBadge !== user?.full_name && <span className="role-badge">{roleBadge}</span>}
                {user && (
                    <Link className="user-link" to="/profile" title={user.full_name + ' — профиль и уведомления'}>
                        {shortName(user.full_name)}
                    </Link>
                )}
                {user && <div className="avatar">{user.initials || initialsOf(user.full_name)}</div>}
                <button
                    type="button"
                    className="link-btn on-dark"
                    onClick={() => void logout()}
                    disabled={logoutPending}
                >
                    Выйти
                </button>
            </div>
        </header>
    );
}

export default Header;
